import { graphql } from '@/gql'
import { useForm } from '@/helpers/useForm'
import { type BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Select } from '../base/select'
import { useQuery } from '@apollo/client/react'
import { LoadingSkeleton } from '../base/loading-skeleton'

const ItemTypesQuery = graphql(`
  query CreateItemItemTypes {
    itemTypes(first: 50) {
      nodes {
        id
        name
      }
    }
  }
`)

const CreateItemMutation = graphql(`
  mutation CreateItem($itemTypeId: ID!, $name: String!) {
    createItem(input: { itemTypeId: $itemTypeId, name: $name }) {
      item { id }
      errors { path message }
    }
  }
`)

export const Create = ({ open, setOpen }: BaseProps) => {
  const navigate = useNavigate()

  const { data, loading } = useQuery(ItemTypesQuery)

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationData,
    mutationLoading,
    attributes,
    formBuilder: { set },
  } = useForm({
    mutation: CreateItemMutation,
    resultKey: 'createItem',
  })

  console.log(attributes)

  useEffect(() => { if (saveSuccess) navigate(`/items/${mutationData?.createItem.item?.id}`) }, [saveSuccess, mutationData, navigate])

  return (
    <Dialog open={ open } size="5xl" onClose={ setOpen }>
      <DialogTitle>New item</DialogTitle>
      <DialogBody>
        {
          loading
            ? <LoadingSkeleton infoPanel title />
            : <div className="flex flex-col gap-6">
              { formBuilder.buildQueryError() }
              { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
              { formBuilder.buildCustomField({
                name: 'Item type',
                field: 'itemTypeId',
                input: <Select value={ attributes.itemTypeId || 'unset' } onChange={ (e: React.ChangeEvent<HTMLSelectElement>) => set('itemTypeId', e.target.value) }>
                  <option value="unset" disabled>No item type selected</option>
                  { data?.itemTypes.nodes.map(it => <option key={ it.id } value={ it.id }>{ it.name }</option>) }
                </Select>
              }) }
              { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
            </div>
        }
      </DialogBody>
    </Dialog>
  )
}
